import { useState, useEffect, useCallback } from 'react';
import { getTodosDatos } from '../api/v1/dashboardApi';
import { useAuth } from '../context/AuthContext';

export const useDashboardData = (periodo = 'semana', fecha_inicio = null, fecha_fin = null) => {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (!user?.token) return;

    setLoading(true);
    setError(null);

    try {
      const result = await getTodosDatos(user.token, periodo, fecha_inicio, fecha_fin);
      console.log('📊 Dashboard data recibida:', result);
      console.log('💰 Moneda:', result.moneda);
      console.log('👥 Top Trabajadores:', result.topTrabajadores);
      setData(result);
    } catch (err) {
      console.error('Error fetching dashboard data:', err);
      setError(err.message || 'Error al cargar datos del dashboard');
    } finally {
      setLoading(false);
    }
  }, [user?.token, periodo, fecha_inicio, fecha_fin]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
};
